const ROUTE_NAMES = {
  BASE_ROUTE: "/",

  MAIN_ROUTES: {
    DASHBOARD: "/dashboard",
    USER_MANAGEMENT: {
      BASE: "/user-management",
      CUSTOMERS: "customers",
      FRANCHISES: "franchises",
      COORDINATORS: "coordinators",
      SERVICE_PARTNERS: "service-partners",
    },
    ADD_USER: "/user-management/add-user",
    EDIT_USER: "/user-management/edit-user",
    USER_DETAIL: "/user-management/user-details",
    UTILITY_MANAGEMENT: "/utility-management",
    SERVICE_MANAGEMENT: "/service-management",
    ADD_SERVICE: "/service-management/add-service",
    SERVICE_DETAIL: "/service-management/service-details",
    SERVICE_PRICING_MANAGEMENT: "/service-pricing-management",
    ORDER: "/order",
    CREATE_ORDER: "/order/create-order",
    COMPANIES: "/companies",
    VEHICLE: "/vehicle",
    TESTIMONIAL: "/testimonial",
    COUPON: "/coupon",
    CREATE_COUPON: "/coupon/create-coupon",
    EDIT_COUPON: "/coupon/edit-coupon",
    COUPON_DETAIL: "/coupon-detail",
    ORDER_DETAIL: "/order-detail",
    EDIT_ORDER: "/order/edit-order",
    UNAUTHORIZED: "/unauthorized",
    FEEDBACK: "/feedback",
  },
};

export default ROUTE_NAMES;
